import {SendDownloadLinkResponse} from "../../pages/api/download-link";
import {nextApi} from "../../utils/fetch/fetches";

export const sendDownloadLink = async ({
  phone,
  practiceSlug,
  captcha,
}: SendDownloadLinkRequest): Promise<SendDownloadLinkResponse> => {
  const response = await nextApi()("/api/download-link", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
    body: JSON.stringify({
      phone,
      practiceSlug,
      captcha,
    }),
  });
  return response.json();
};

export type SendDownloadLinkRequest = {
  phone: string | null;
  practiceSlug: string;
  captcha: string | null;
};
